"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactComponents = require("@ui-propulsion/react-components");
var useStyles = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
  var palette = theme.palette,
    typography = theme.typography;
  var fontFamilyRegular = typography.fontFamilyRegular,
    pxToRem = typography.pxToRem;
  return {
    root: {
      fontFamily: fontFamilyRegular,
      padding: 0
    },
    accountContainer: {
      marginBottom: pxToRem(20),
      marginLeft: pxToRem(4),
      display: 'flex',
      alignItems: 'baseline'
    },
    accountCheckContainer: {
      marginRight: pxToRem(11)
    },
    account: {
      color: palette.denim[500],
      margin: '0',
      display: 'flex',
      flexDirection: 'column'
    },
    institution: {
      marginBottom: pxToRem(4)
    },
    accountIcon: {
      '& .MuiIconButton-label > span': {
        backgroundColor: palette.common.white,
        boxShadow: 'none',
        '& svg': {
          color: palette.sapphire[500]
        }
      }
    },
    balance: {
      margin: '0',
      color: palette.neutral.narwhal,
      fontFamily: fontFamilyRegular,
      fontSize: pxToRem(14)
    }
  };
}, {
  name: 'PlaidSingleAccount'
});
exports.useStyles = useStyles;
